import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import useCountryCodes from '../../../hooks/useCountryCodes';
import { useAddressModalStore } from '../../../store/address/addressModalStore';
import { useShoppingCartStore } from '../../../store/shoppingCart/shoppingCartStore';

export const addressFormSchema = z
    .object({
        foreigner: z.boolean().optional().default(false),
        // name: z
        //     .string()
        //     .min(1, { message: 'Campo obrigatório' })
        //     .refine(val => val.trim().split(' ').length > 1, {
        //         message: 'Informe o nome completo',
        //     }),
        // document: z.string(),
        // cep: z.string(),
        address: z.string(),
        number: z.string(),
        neighborhood: z.string(),
        city: z.string(),
        state: z.string(),
        complement: z.string().optional(),
        zipCode: z.string(),
        countryIso2: z.string(),
    })
    .superRefine((data, ctx) => {
        if (data.foreigner) {
            if (data.zipCode.length < 1) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    path: ['zipCode'],
                    message: 'Campo obrigatório',
                });
            }
            // if (data.document.length < 1) {
            //     ctx.addIssue({
            //         code: z.ZodIssueCode.custom,
            //         path: ['document'],
            //         message: 'Campo obrigatório',
            //     });
            // }
        } else {
            // if (!validateCPFCNPJ(data.document, true)) {
            //     ctx.addIssue({
            //         code: z.ZodIssueCode.custom,
            //         path: ['document'],
            //         message: 'CPF inválido',
            //     });
            // }
            if (data.zipCode.length < 9) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    path: ['zipCode'],
                    message: 'Campo obrigatório',
                });
            }
            if (data.address.length < 1) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    path: ['address'],
                    message: 'Campo obrigatório',
                });
            }
            if (data.number.length < 1) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    path: ['number'],
                    message: 'Campo obrigatório',
                });
            }
            if (data.neighborhood.length < 1) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    path: ['neighborhood'],
                    message: 'Campo obrigatório',
                });
            }
            if (data.city.length < 1) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    path: ['city'],
                    message: 'Campo obrigatório',
                });
            }
            if (data.state.length < 1) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    path: ['state'],
                    message: 'Campo obrigatório',
                });
            }
        }
    });

export type AddressFormSchemaType = z.infer<typeof addressFormSchema>;

export default function useFormModalAddressLogic() {
    const addressModal = useAddressModalStore();
    const shoppingCartStore = useShoppingCartStore();
    const countryCodes = useCountryCodes();

    const {
        register,
        handleSubmit,
        getValues,
        formState: { errors, isValid, validatingFields },
        setValue,
        trigger,
        watch,
    } = useForm<AddressFormSchemaType>({
        resolver: zodResolver(addressFormSchema),
        mode: 'onBlur',
        defaultValues: {
            foreigner: addressModal.address.foreigner,
            // name: addressModal.address.name || '',
            // document: addressModal.address.document || '',
            zipCode: addressModal.address.zipCode || '',
            address: addressModal.address.address || '',
            number: addressModal.address.number || '',
            neighborhood: addressModal.address.neighborhood || '',
            city: addressModal.address.city || '',
            state: addressModal.address.state || 'AC',
            complement: addressModal.address.complement || '',
            countryIso2: addressModal.address.countryIso2 || 'BR',
        },
    });

    function handleSuccess(data: AddressFormSchemaType) {
        if (!countryCodes.data) return;
        if (isValid) {
            const address = {
                foreigner: data.foreigner,
                // name: data.name,
                // document: data.document,
                // cep: data.cep,
                address: data.address,
                number: data.number,
                neighborhood: data.neighborhood,
                city: data.city,
                state: data.state,
                complement: data.complement || '',
                zipCode: data.zipCode,
                countryIso2: data.countryIso2,
            };
            addressModal.update({
                isVisible: false,
                isValid: true,
                address,
            });

            shoppingCartStore.setAddress({
                ...address,
                countryId: countryCodes.data.find(
                    d => d.iso2 === address.countryIso2
                )!.id,
            });
        }
    }

    const handleError = (_formErrors: typeof errors) => {
        
    };

    return {
        register,
        errors,
        validatingFields,
        handleSubmit,
        handleSuccess,
        handleError,
        getValues,
        setValue,
        trigger,
        watch,
    };
}
